import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./admin-icon.css?inline";

@customElement("eko-admin-icon")
class AdminIcon extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) tooltip: boolean = false;

  render() {
    return html`
      ${this.tooltip
        ? html`<eko-tooltip arrow position="right" aria-label="Admin only"
            ><eko-icon name="fingerprint-01"></eko-icon
            ><span slot="content">Admin only</span></eko-tooltip
          >`
        : html`<eko-icon name="fingerprint-01"></eko-icon>`}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-admin-icon": AdminIcon;
  }
}

export default AdminIcon;
